import {
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Divider,
  Grid,
  IconButton,
  Paper,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import SearchBar from "../../components/common/SearchBar";
import UserProfileContext from "../../context/userProfile/UserProfileContext";
import OrdersAPI from "../../api/firebase/OrdersAPI";
import Loader from "../../components/loader/Loader";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useNavigate } from "react-router-dom";
import ProductsContainer from "../../components/app/Products/ProductsContainer";
import AllProductContext from "../../context/allProducts/AllProductsContext";
import RecentlyViewedContext from "../../context/recentlyViewed/RecentlyViewedContext";
import CustomButton from "../../components/common/Button/CustomButton";
import { formatDateToCustomFormat, getDateFromCreatedAt } from "../../utils/dateUtils";

const UserOrdersPage = () => {
  const userProfileContext = useContext(UserProfileContext);
  const allProductsContext = useContext(AllProductContext);
  const recentlyViewedContext = useContext(RecentlyViewedContext);
  const recentlyViewedItemsArray = recentlyViewedContext.state;
  const [orders, setOrders] = useState([]);
  const [detailedOrders, setDetailedOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const ordersAPI = new OrdersAPI();
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState({});
  const [searchText, setSearchText] = useState("");
  const navigate = useNavigate();



  useEffect(() => {
    console.log(
      "🔍 UserOrdersPage: userProfileContext.state changed:",
      userProfileContext.state
    );

    if (userProfileContext.state !== null) {
      setUser(userProfileContext.state);
      console.log("👤 User set:", userProfileContext.state);
    }

    if (
      userProfileContext.state !== null &&
      userProfileContext.state.orders !== undefined
    ) {
      console.log("📋 Raw user orders:", userProfileContext.state.orders);
      console.log(
        "📊 Number of orders:",
        userProfileContext.state.orders.length
      );

      // Log each order status
      userProfileContext.state.orders.forEach((order, index) => {
        console.log(
          `📦 Order ${index + 1}: ID=${order.id}, Status=${
            order.status
          }, CreatedAt=${order.createdAt}`
        );
      });

      let sortedOrders = userProfileContext.state.orders.sort(
        (a, b) =>
          getDateFromCreatedAt(b.createdAt) - getDateFromCreatedAt(a.createdAt)
      );
      console.log("📋 Sorted orders:", sortedOrders);
      setOrders(sortedOrders);
    } else {
      console.log("❌ No orders found in user context");
      setOrders([]);
    }
  }, [userProfileContext.state]);

  useEffect(() => {
    let orderDetail = [];

    if (orders.length > 0) {
      setLoading(true);
      orders.map(async (order, index) => {
        // console.log("order id:", order.id);
        await ordersAPI.getOrderDetailById(order.id).then((res) => {
          //console.log("getOrderDetailById RES:", res);
          orderDetail.push(res);
          if (index === orders.length - 1) {
            setDetailedOrders(orderDetail);
            setTimeout(() => {
              setLoading(false);
            }, 500);
          }
        });
      });
    } else {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, [orders]);

  useEffect(() => {
    // console.log("detailedOrders CHANGED:", detailedOrders);

    if (searchText.length > 2) {
      const filtered = detailedOrders.filter((order) => {
        let allTitles = "";
        const items = Array.isArray(order.items) ? order.items : [];
        items.forEach((item) => {
          allTitles = allTitles + " " + (item?.title || "");
        });
        return allTitles.toLowerCase().includes(searchText.toLowerCase());
      });
      setFilteredOrders(filtered);
    } else {
      setFilteredOrders(detailedOrders);
    }
    if (detailedOrders.length !== 0) {
      setTimeout(() => {}, 500);
    }
  }, [detailedOrders, searchText]);
  // useEffect(() => {
  //   console.log("filteredOrders CHANGED:", filteredOrders);
  // }, [filteredOrders]);

  function onSearchTextChange(e) {
    const enteredValue = e.currentTarget.value;
    setSearchText(enteredValue);
  }
  const isPaymentProcessing = (order) => {
    // If user closed the payment modal, do not consider it processing
    if (order?.payment?.modalClosed === true) {
      return false;
    }
    const orderAt = getDateFromCreatedAt(order.createdAt);
    const nowDate = new Date();

    // date diffrence in minutes
    const diff = (nowDate - orderAt) / 60000;
    // console.log(
    //   "order at:" + orderAt + " nowDate:" + nowDate + "\n diff:" + diff
    // );
    if (diff < 5) {
      return true;
    }
    return false;
  };

  return (
    <>
      {!loading && (
        <Container
          maxWidth={detailedOrders.length > 0 ? "lg" : "lg"}
          sx={{
            marginTop: { xs: "1rem", sm: "2rem" },
            marginBottom: { xs: "1rem", sm: "2rem" },
            px: { xs: 1, sm: 2 },
          }}
        >
          {detailedOrders.length > 0 && (
            <>
              {/* Enhanced Header Section */}
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="h4"
                  component="h1"
                  sx={{
                    fontWeight: 600,
                    mb: 1,
                    color: "text.primary",
                    fontSize: { xs: "1.5rem", sm: "2rem", md: "2.125rem" },
                  }}
                >
                  Your Orders
                </Typography>
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{ mb: 3 }}
                >
                  Track and manage all your orders in one place
                </Typography>

                <SearchBar
                  placeholderText="Search your orders..."
                  variant="border"
                  onSearchTextChange={onSearchTextChange}
                  searchText={searchText}
                />
              </Box>
            </>
          )}

          {/* Enhanced Order Cards */}
          {!loading &&
            filteredOrders.length > 0 &&
            filteredOrders.map((order, index) => {
              let date = getDateFromCreatedAt(order.createdAt);
              let ex_date = date.setDate(date.getDate() + 8);
              let expectedDD = formatDateToCustomFormat(new Date(ex_date));

              // Enhanced status logic with better labels and colors
              let statusInfo = {};
              switch (order.status.toUpperCase()) {
                case "CREATED":
                  if (isPaymentProcessing(order)) {
                    statusInfo = {
                      label: "Processing payment",
                      chipColor: "warning",
                      chipVariant: "filled",
                    };
                  } else {
                    statusInfo = {
                      label: "Payment Pending",
                      chipColor: "error",
                      chipVariant: "filled",
                    };
                  }
                  break;
                case "PLACED":
                  statusInfo = {
                    label: "Order Confirmed",
                    subtitle: `Expected delivery: ${expectedDD}`,
                    chipColor: "info",
                    chipVariant: "filled",
                  };
                  break;
                case "SHIPPED":
                  statusInfo = {
                    label: "Shipped",
                    subtitle: "On the way to you",
                    chipColor: "primary",
                    chipVariant: "filled",
                  };
                  break;
                case "OUT FOR DELIVERY":
                  statusInfo = {
                    label: "Out for Delivery",
                    subtitle: "Will be delivered today",
                    chipColor: "primary",
                    chipVariant: "filled",
                  };
                  break;
                case "DELIVERED":
                  statusInfo = {
                    label: "Delivered",
                    subtitle: `Delivered on ${
                      order.deliveredAt ? formatDateToCustomFormat(getDateFromCreatedAt(order.deliveredAt)) : "N/A"
                    }`,
                    chipColor: "success",
                    chipVariant: "filled",
                  };
                  break;
                case "CANCELLED BY BUYER":
                  statusInfo = {
                    label: "Cancelled",
                    subtitle: `Cancelled on ${
                      order.cancelledAt ? formatDateToCustomFormat(getDateFromCreatedAt(order.cancelledAt)) : "N/A"
                    }`,
                    chipColor: "default",
                    chipVariant: "outlined",
                  };
                  break;
                case "CANCELLED BY SELLER":
                  statusInfo = {
                    label: "Cancelled by Seller",
                    subtitle: `Cancelled on ${
                      order.cancelledAt ? formatDateToCustomFormat(getDateFromCreatedAt(order.cancelledAt)) : "N/A"
                    }`,
                    chipColor: "default",
                    chipVariant: "outlined",
                  };
                  break;
                default:
                  statusInfo = {
                    label: order.status || "Unknown",
                    chipColor: "default",
                    chipVariant: "outlined",
                  };
              }

              return (
                <Card
                  key={index}
                  sx={{
                    mb: 2,
                    cursor: "pointer",
                    transition: "all 0.2s ease-in-out",
                    "&:hover": {
                      transform: "translateY(-2px)",
                      boxShadow: 3,
                    },
                    border: "1px solid",
                    borderColor: "divider",
                  }}
                  onClick={() =>
                    navigate("/orderDetail", { state: { order: order } })
                  }
                >
                  <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                    <Grid
                      container
                      spacing={{ xs: 1.5, sm: 2 }}
                      alignItems="center"
                    >
                      {/* Product Images */}
                      <Grid item xs={12} sm={4} md={2}>
                        <Box sx={{ display: "flex", justifyContent: "center" }}>
                          {Array.isArray(order.items) &&
                          order.items.length > 1 ? (
                            <AvatarGroup max={2} sx={{ flexDirection: "row" }}>
                              {(order.items || []).map((item, id) => (
                                <Avatar
                                  key={id}
                                  alt={item?.title || ""}
                                  src={item?.images?.[0]?.url || ""}
                                  sx={{
                                    width: 56,
                                    height: 56,
                                    border: "2px solid white",
                                  }}
                                  variant="rounded"
                                />
                              ))}
                            </AvatarGroup>
                          ) : (
                            Array.isArray(order.items) &&
                            order.items.length === 1 && (
                              <Avatar
                                alt={order.items[0]?.title || ""}
                                src={order.items[0]?.images?.[0]?.url || ""}
                                sx={{
                                  width: 80,
                                  height: 80,
                                }}
                                variant="rounded"
                              />
                            )
                          )}
                        </Box>
                      </Grid>

                      {/* Order Details */}
                      <Grid item xs={12} sm={5} md={7}>
                        <Stack spacing={1}>
                          {/* Status Chip */}
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <Chip
                              label={statusInfo.label}
                              color={statusInfo.chipColor}
                              variant={statusInfo.chipVariant}
                              size="small"
                              sx={{ fontWeight: 500 }}
                            />
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Order #{order.id || "N/A"}
                            </Typography>
                          </Box>

                          {/* Product Names */}
                          <Typography
                            variant="body1"
                            sx={{
                              fontWeight: 500,
                              color: "text.primary",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                              overflow: "hidden",
                              fontSize: { xs: "0.875rem", sm: "1rem" },
                            }}
                          >
                            {(Array.isArray(order.items) ? order.items : [])
                              .map((item) => item?.title || "")
                              .join(", ") || "No items"}
                          </Typography>

                          {/* Status Subtitle */}
                          {statusInfo.subtitle && (
                            <Typography variant="body2" color="text.secondary">
                              {statusInfo.subtitle}
                            </Typography>
                          )}
                        </Stack>
                      </Grid>

                      {/* Amount and Arrow */}
                      <Grid item xs={12} sm={3} md={3}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: { xs: "row", sm: "column" },
                            justifyContent: {
                              xs: "space-between",
                              sm: "center",
                            },
                            alignItems: { xs: "center", sm: "flex-end" },
                            height: "100%",
                            gap: { xs: 1, sm: 1.5 },
                            mt: { xs: 1, sm: 0 },
                          }}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 700,
                              color: "primary.main",
                              fontSize: { xs: "1.1rem", sm: "1.25rem" },
                            }}
                          >
                            ₹{order.amount}
                          </Typography>

                          <Typography variant="caption" color="text.secondary">
                            {formatDateToCustomFormat(date)}
                          </Typography>
                          <IconButton
                            size="small"
                            sx={{
                              ml: { xs: "auto", sm: 0 },
                              color: "action.active",
                            }}
                          >
                            <KeyboardArrowRightIcon />
                          </IconButton>
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              );
            })}

          {/* Enhanced Empty States */}
          {!loading &&
            filteredOrders.length === 0 &&
            detailedOrders.length > 0 && (
              <Card sx={{ mt: 4, p: { xs: 2, sm: 4 }, textAlign: "center" }}>
                <CardContent>
                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="h1"
                      sx={{ fontSize: { xs: "3rem", sm: "4rem" }, mb: 2 }}
                    >
                      🔍
                    </Typography>
                    <Typography
                      variant="h5"
                      gutterBottom
                      sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}
                    >
                      No orders found
                    </Typography>
                    <Typography
                      variant="body1"
                      color="text.secondary"
                      sx={{ mb: 3, fontSize: { xs: "0.875rem", sm: "1rem" } }}
                    >
                      We couldn't find any orders matching your search criteria.
                      Try adjusting your filters or search terms.
                    </Typography>
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setSearchText("");
                      }}
                      sx={{
                        mr: { xs: 1, sm: 2 },
                        minHeight: { xs: "40px", sm: "auto" },
                      }}
                    >
                      Clear Search
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => navigate("/")}
                      sx={{ minHeight: { xs: "40px", sm: "auto" } }}
                    >
                      Continue Shopping
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            )}

          {!loading && detailedOrders.length === 0 && (
            <Card sx={{ mt: 4, p: { xs: 2, sm: 4 }, textAlign: "center" }}>
              <CardContent>
                <Box sx={{ mb: { xs: 3, sm: 4 } }}>
                  <Typography
                    variant="h1"
                    sx={{ fontSize: { xs: "3rem", sm: "5rem" }, mb: 2 }}
                  >
                    📦
                  </Typography>
                  <Typography
                    variant="h4"
                    gutterBottom
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: "1.5rem", sm: "2.125rem" },
                    }}
                  >
                    No orders yet
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{
                      mb: { xs: 3, sm: 4 },
                      maxWidth: 400,
                      mx: "auto",
                      fontSize: { xs: "0.875rem", sm: "1rem" },
                    }}
                  >
                    You haven't placed any orders yet. Start shopping to see
                    your order history here.
                  </Typography>

                  {/* Action Buttons */}
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={2}
                    justifyContent="center"
                    sx={{ mb: 4 }}
                  >
                    {user.cartItems !== undefined &&
                      user.cartItems !== null &&
                      user.cartItems.length > 0 && (
                        <Button
                          variant="contained"
                          size="large"
                          onClick={() => navigate("/cart")}
                          sx={{ minWidth: 160 }}
                        >
                          Complete Cart ({user.cartItems.length} items)
                        </Button>
                      )}
                    <Button
                      variant={
                        user.cartItems?.length > 0 ? "outlined" : "contained"
                      }
                      size="large"
                      onClick={() => navigate("/")}
                      sx={{ minWidth: 160 }}
                    >
                      Start Shopping
                    </Button>
                  </Stack>
                </Box>

                <Divider sx={{ my: 4 }} />

                {/* Product Suggestions */}
                <Box>
                  <ProductsContainer
                    heading="Discover Our Products"
                    showInRow={true}
                    addToCartEnable={true}
                    showCarousel={false}
                    productsArray={allProductsContext.state}
                  />
                </Box>

                {/* Recently Viewed Items */}
                {recentlyViewedItemsArray.length > 0 && (
                  <Box sx={{ mt: 4 }}>
                    <Divider sx={{ my: 4 }} />
                    <ProductsContainer
                      heading="Continue Where You Left Off"
                      showInRow={true}
                      addToCartEnable={true}
                      showCarousel={false}
                      productsArray={recentlyViewedItemsArray}
                    />
                  </Box>
                )}
              </CardContent>
            </Card>
          )}
        </Container>
      )}
      {/* Enhanced Loading States */}
      {loading && (
        <Container 
          maxWidth="lg" 
          sx={{
            marginTop: { xs: "1rem", sm: "2rem" },
            marginBottom: { xs: "1rem", sm: "2rem" },
            px: { xs: 1, sm: 2 },
          }}
        >
          {/* Header Skeleton */}
          <Box sx={{ mb: 4 }}>
            {/* Title Skeleton */}
            <Skeleton 
              variant="text" 
              width="40%" 
              height={48} 
              sx={{ 
                mb: 1,
                fontSize: { xs: "1.5rem", sm: "2rem", md: "2.125rem" }
              }} 
            />
            {/* Description Skeleton */}
            <Skeleton 
              variant="text" 
              width="60%" 
              height={24} 
              sx={{ mb: 3 }}
            />
            {/* Search Bar Skeleton */}
            <Skeleton 
              variant="rounded" 
              height={56} 
              sx={{ borderRadius: 2 }}
            />
          </Box>

          {/* Order Cards Skeleton */}
          {[1, 2, 3].map((item) => (
            <Card key={item} sx={{ mb: 2 }}>
              <CardContent sx={{ p: 3 }}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={3} md={2}>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <Skeleton variant="rounded" width={80} height={80} />
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6} md={7}>
                    <Stack spacing={1}>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <Skeleton variant="rounded" width={100} height={24} />
                        <Skeleton variant="text" width={120} height={20} />
                      </Box>
                      <Skeleton variant="text" width="80%" height={24} />
                      <Skeleton variant="text" width="60%" height={20} />
                    </Stack>
                  </Grid>
                  <Grid item xs={12} sm={3} md={3}>
                    <Stack alignItems="flex-end" spacing={1}>
                      <Skeleton variant="text" width={80} height={28} />
                      <Skeleton variant="text" width={100} height={16} />
                    </Stack>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          ))}
        </Container>
      )}
    </>
  );
};

export default UserOrdersPage;
